import "../../styles/blocks/gallery.scss";

import { registerBlockType } from "@wordpress/blocks";
import blockJson from "../../../includes/blocks/content-gallery/block.json";

import { useBlockProps } from "@wordpress/block-editor";
import { Panel, PanelBody, PanelHeader, CustomSelectControl, CheckboxControl, TextControl } from "@wordpress/components";
import { useSelect } from '@wordpress/data';

import { map } from "react-itertools";

import { __ } from "@wordpress/i18n";

import React, { Component } from "react";
import Parser from "html-react-parser";


export default class ContentGalleryBlock extends Component {

	constructor(props) {
		super(props);
		this.numberOfElements = parseInt(props.numberOfElements);
		this.tags = props.tags?.split(",").map((item) => item.trim()) ?? [];
		this.selectedTag = null;
		this.searchInputRef = React.createRef();
		this.tagSelectRef = React.createRef();
	}


    static register() {
        registerBlockType(blockJson, {
            edit: this.edit,
            save: this.save,
        });
    }



    static initialize(container) {
		let contents = container.innerHTML
							.replace(/\n/g, "")
							.replace(/[\t ]+\</g, "<")
							.replace(/\>[\t ]+\</g, "><")
							.replace(/\>[\t ]+$/g, ">")
		contents = Parser(contents);
		
        ReactDOM.render(
            <ContentGalleryBlock
				numberOfElements={container.dataset.numberOfElements}
				tags={container.dataset.tags}
			>
                {contents}
            </ContentGalleryBlock>,
            container
        );
		container.classList.remove("loading");
    }

	static initializeAll() {
        window.addEventListener("load", function() {
            
            const contentGalleryDivs = document.getElementsByClassName("gallery-container");

            for (const div of contentGalleryDivs) {
                ContentGalleryBlock.initialize(div);
            }
        });
	}

    

    static edit(props) {
		const { attributes, setAttributes } = props;

		const blockProps = useBlockProps({
			className: "svcv-content-gallery-block-container"
		});
		const controlProps = useBlockProps({
			className: "svcv-content-gallery-block-controls"
		});
		

		const {postTypesRef, categoriesRef, taxonomiesRef} = useSelect((select) => {
			const postTypes = (select('core').getPostTypes( { per_page: -1, } ) ?? [])
				.map((item) => {
					return {
						key: item.slug,
						name: item.name,
					}
				});

			const categories = (select('core').getEntityRecords('taxonomy', 'category', { per_page: -1}) ?? [])
				.map((item) => {
					return {
						key: item.id,
						name: item.name
					}
				});

			if (categories.length > 0 && categories[0].key !== 0) {
				categories.unshift(
					{
						key: 0,
						name: __('All Categories', 'svcv'),
					}
				);
			}

			const taxonomies = (select('core').getTaxonomies( { per_page: -1, } ) ?? [])
				.map((item) => {
					console.log(item);
					return {
						key: item.slug,
						name: item.name,
					}
				});

			return {postTypesRef: postTypes, categoriesRef: categories, taxonomiesRef: taxonomies};
		}, []);

		// let taxonomiesRef = [];

		// function updateTaxonomies() {
		// 	taxonomiesRef = taxonomies
		// 		.filter((item) => item.slug !== "post_tag")
		// 		.map((item) => {
		// 			return {
		// 				key: item.slug,
		// 				name: item.name,
		// 			}
		// 		});
				
		// }

		const sortingOrders = [
			{
				key: 'DESC',
				name: 'Du plus récent au plus ancien'
			},
			{
				value: 'ASC',
				name: 'Du plus ancien au plus récent'
			},
		];
	
	
		return (
			<div {...blockProps}>
				<Panel {...blockProps}>
					<PanelHeader> Galerie de Contenu </PanelHeader>
					<PanelBody {...controlProps}>
						<TextControl
							label="Nombre d'éléments"
							value={attributes.numberOfElements == -1 ? __('All', 'svcv') : attributes.numberOfElements}
							onChange={(selected) => {
								let newValue = parseInt(selected);
								if (isNaN(newValue)) newValue = -1;

								setAttributes({numberOfElements: newValue})
							}}
						/>
						<CustomSelectControl
							label={__( 'Content type', 'svcv')}
							options={ postTypesRef }
							value={ postTypesRef.find( (item) => item.key === attributes.postType ) }
							onChange={ (event) => setAttributes({ postType: event.selectedItem.key }) }
						/>
						<CheckboxControl
							label={__( 'Is Tag Selection Gallery', 'svcv')}
							checked={ attributes.tagSelection }
							onChange={ (value) => setAttributes({ tagSelection: value }) }
						/>
						<CustomSelectControl
							label={__( 'Category', 'svcv')}
							options={ categoriesRef }
							value={ categoriesRef.find( (item) => parseInt(item.key) === attributes.categoryId ) }
							onChange={ (event) => setAttributes({ categoryId: parseInt(event.selectedItem.key) }) }
						/>
						<CustomSelectControl
							label={__("Taxonomy", 'svcv')}
							options={ taxonomiesRef }
							value={ taxonomiesRef.find( (item) => item.key === attributes.taxonomy ) }
							onChange={ (event) => setAttributes({ taxonomy: parseInt(event.selectedItem.key)}) }
						/>
						<CustomSelectControl
							label={__( 'Sorting order', 'svcv')}
							options={ sortingOrders }
							value={ sortingOrders.find( (item) => item.key === attributes.sortingOrder ) }
							onChange={ (event) => setAttributes({ sortingOrder: event.selectedItem.key }) }
						/>
					</PanelBody>
				</Panel>
			</div>
		);
		
	}

    static save() {
        return null;
    }


    render() {
		const children = this.props.children;
		let contents = this.numberOfElements === -1 ? children : children.slice(0, this.numberOfElements);

		const getTextContent = (element) => {
			if (typeof element === "string") {
				return element;
			}
		  
			if (React.isValidElement(element)) {
				const children = React.Children.toArray(element.props.children);
				return children.map((child) => getTextContent(child)).join("");
			}
		  
			return "";
		}

		if (this.selectedTag !== null) {
			contents = React.Children.map(contents, (child) => {
				if (React.isValidElement(child)) {
					const infoContainer = child.props.children.find((item) => item.props.className === "info");
					if (infoContainer === undefined) return null;
					const infoTagContainer = infoContainer.props.children.find((item) => item.props.className === "info-tag-container");
					if (infoTagContainer === undefined || infoTagContainer.props.children === null) return null;

					if (infoTagContainer.props.children.length > 1) {
						const tags = infoTagContainer.props.children.filter((item) => item.props.className === "info-tag");
						if (tags.length === 0) return null;
						if (tags.find((item) => getTextContent(item) === this.selectedTag.innerText) !== undefined) {
							return child;
						}
					} else if (getTextContent(infoTagContainer) === this.selectedTag.innerText) {
						return child;
					}
					
				}
				return null;
			}).filter(Boolean);
		}


		if ( this.searchInputRef.current ) {

			contents = React.Children.map(contents, (child) => {
				if (React.isValidElement(child)) {
					const content = getTextContent(child);
					const lowerContent = content.toLowerCase();
					if (lowerContent.includes(this.searchInputRef.current.value.toLowerCase())) {
						return child;
					}
				}
				return null;
			}).filter(Boolean);
		}
		
		const handleSelectTagFilter = (event) => {
			if (this.selectedTag !== null) {
				this.selectedTag.classList.remove("selected");
			}
			if (this.selectedTag !== event.target) {
				this.selectedTag = event.target;
				event.target.classList.add("selected");
			} else {
				this.selectedTag = null;
			}
			this.forceUpdate();
		}

		const handleSearch = () => {
			this.forceUpdate();
		}

		return (
			<>
				<input ref={this.searchInputRef} onChange={handleSearch} type="text" placeholder={__( /* 'Search' TODO: Fix translation */ 'Rechercher', 'svcv')} /> 
				<div ref={this.tagSelectRef} className="info-tag-container">
					{map(this.tags, (tag) => {
						return (
							<div className="info-tag" onClick={handleSelectTagFilter}>
								{tag}
							</div>
						);
					})}
				</div>
				<div className="gallery-contents">
					{contents}
				</div>
			</>
		);
    }
}